'use client'

import { Suspense, useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import posthog from 'posthog-js'

function currentPath() {
  return window.location.pathname + window.location.search + window.location.hash
}

function PostHogInit() {
  useEffect(() => {
    const key = process.env.NEXT_PUBLIC_ANALYTICS_KEY
    if (!key) return

    posthog.init(key, {
      api_host: '/analytics',
      ui_host: 'https://us.posthog.com',
      capture_pageview: false,
      capture_pageleave: true,
      autocapture: false,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: { password: true },
      },
    })
  }, [])

  return null
}

function PageViewTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!process.env.NEXT_PUBLIC_ANALYTICS_KEY) return
    posthog.capture('$pageview', {
      $current_url: currentPath(),
      $referrer: document.referrer || '',
    })
  }, [pathname, searchParams])

  return null
}

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  if (!process.env.NEXT_PUBLIC_ANALYTICS_KEY) return <>{children}</>

  return (
    <>
      <PostHogInit />
      <Suspense>
        <PageViewTracker />
      </Suspense>
      {children}
    </>
  )
}
